import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { FC } from "react";
import { SendReportCaseV1FinanceDetailsTransactionAdhocTransaction } from "../../../../../../../../generated";
import { DATE_FORMAT } from "../../../../../../../../constants";
dayjs.extend(utc);

export interface TransactionsPDFProps {
  data: TransactionPdfData;
}

export interface TransactionPdfData {
  tableData: SendReportCaseV1FinanceDetailsTransactionAdhocTransaction;
}

const styles = StyleSheet.create({
  body: {
    padding: 15,
    margin: 2,
    fontSize: 14,
    height: "90%",
  },
  title: {
    fontFamily: "Helvetica-Bold",
    fontSize: 20,
    marginBottom: 10,
  },
  horizontalLine: {
    borderTop: 2,
    borderColor: "black",
    height: 2,
    marginBottom: 5,
    marginTop: 2,
  },
  table: {
    display: "flex",
    width: "100%",
    marginBottom: 5,
    paddingRight: 20,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
    marginBottom: 15,
  },
  tableCell: {
    fontSize: 10,
  },
  label: {
    fontFamily: "Times-Roman",
    fontSize: 9,
    marginBottom: 5,
  },
  content: {
    fontSize: 11,
  },
});

interface InfoGroupProps {
  label: string;
  content: string;
}

const InfoGroup: FC<InfoGroupProps> = (props) => {
  return (
    <>
      <Text style={styles.label}>{props.label}</Text>
      <Text style={styles.content}>{props.content}</Text>
    </>
  );
};

export const TransactionsGeneratePdf: FC<TransactionsPDFProps> = (props) => {
  const tranData = props.data.tableData;
  const refId = tranData?.transactionReference?.referenceId ?? "";
  const isRefund = tranData?.approval?.isApplicantApprovalRequired === null || tranData?.approval=== null;
  return (
    <Document title={`Application - ${refId}`}>
      <Page orientation="landscape" size="A4" style={styles.body}>
        <View style={styles.horizontalLine}></View>
        <View style={styles.title}>
          <Text>Transactions Summary</Text>
        </View>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={{ width: "50%" }}>
              <View style={styles.tableCell}>
                <InfoGroup label={"Transaction ID:"} content={refId} />
              </View>
            </View>
            <View style={{ width: "50%" }}>
              <View style={styles.tableCell}>
                <InfoGroup label={"Transaction Date:"} content={tranData?.createdAt ? dayjs(tranData.createdAt).utc().format(DATE_FORMAT).toUpperCase() : "N/A"} />
              </View>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={{ width: "50%" }}>
              <View style={styles.tableCell}>
                <InfoGroup label={"Description:"} content={tranData?.reason ?? "N/A"} />
              </View>
            </View>
            <View style={{ width: "50%" }}>
              <View style={styles.tableCell}>
              <InfoGroup label={isRefund ? 'Refund Amount' : 'Amount Paid'} content={tranData?.amount !== undefined ? `US$${Math.abs(tranData.amount || 0)}` : "N/A"} />
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};
